import { NavLink, useLocation } from 'react-router-dom';
import LogoutIcon2 from '../../assets/icons/logout2.svg';
import './Sidebar.scss';
import useAuth from '../../hooks/useAuth';
import { useEffect, useState } from 'react';
import Close from '../../assets/icons/close.svg';
import PiggyvestLogo from '../../assets/images/faas.svg';
import ThreeUsers from '../../assets/icons/three-users.svg';
import SettingsIcon from '../../assets/icons/settings.svg';
import USDRequests from '../../assets/icons/USD-Requests.svg';
import ReciptImg from '../../assets/icons/receipt.svg';
import WithdrawalManager from '../../assets/icons/withdrawal-manager.svg';
import HomeIcon from '../../assets/icons/home.svg';
import SiteConfig from '../../assets/icons/site-configuration.svg';
import PaymentProcessor from '../../assets/icons/payment-prcoessor.svg';
import { ADMIN_ROLES, localStorageEnum } from '../../api/enums';
import { IoChevronDown } from 'react-icons/io5';
import { SidebarProps } from '../../types';

const Sidebar = ({ onClose }: SidebarProps) => {
  const { logout } = useAuth();
  const location = useLocation();
  const [currentUser, setCurrentUser] = useState<{ firstName: string; lastName: string; email: string }>();
  const [showWithdrawalDropdown, setShowWithdrawalDropdown] = useState(false);
  const [showSiteConfigDropdown, setShowSiteConfigDropdown] = useState(false);
  const [showUsdDropdown, setShowUsdDropdown] = useState(false);

  useEffect(() => {
    const user = {
      firstName: localStorage.getItem(localStorageEnum['local.storage.firstName']),
      lastName: localStorage.getItem(localStorageEnum['local.storage.lastName']),
      email: localStorage.getItem(localStorageEnum['local.storage.email']),
    };
    if (user.email) {
      setCurrentUser({
        firstName: user.firstName!,
        lastName: user.lastName!,
        email: user.email!,
      });
    }
  }, [location.pathname]);

  const customerNav = () => {
    return localStorage.getItem('activeCustomer')
      ? `/customer/${localStorage.getItem('activeCustomer')}`
      : '/customers';
  };

  const adminRole = localStorage.getItem(localStorageEnum['local.storage.role']) ?? '';
  const showAdminOptions = adminRole === ADMIN_ROLES.super_admin;

  const adminComplianceUserIds = ['36439545a01219', '6764d09d7e5'];

  const showAdminComplianceOptions = adminComplianceUserIds.includes(
    localStorage.getItem(localStorageEnum['local.storage.userId']) ?? '',
  );

  return (
    <aside className="sidebar">
      <div className="sidebar__logo">
        <img src={PiggyvestLogo} alt="piggyvest logo" />
        <div className="head pointer" onClick={onClose}>
          <img src={Close} alt="close icon" />
        </div>
      </div>

      <div className="sidebar__content">
        <div className="sidebar__links">
          <ul>
            <li>
              <NavLink to={'/'} onClick={onClose} className={location.pathname === '/' ? 'active pointer' : ''}>
                <img src={HomeIcon} alt="" />
                Overview
              </NavLink>
            </li>
            <li>
              <NavLink
                to={customerNav()}
                onClick={onClose}
                className={
                  location.pathname.includes('customer') || location.pathname.includes('view-all-target')
                    ? 'active pointer'
                    : ''
                }
              >
                <img src={ThreeUsers} alt="" />
                Customers
              </NavLink>
            </li>

            {/* --- Withdrawal Dropdown --- */}
            <li className="sidebar__withdrawal-manager">
              <div className="text-caret flex--2">
                <NavLink
                  to={'/withdrawal-manager'}
                  onClick={onClose}
                  className={location.pathname.includes('withdrawal') ? 'active' : ''}
                >
                  <img src={WithdrawalManager} alt="" />
                  Withdrawal Manager
                </NavLink>

                <div
                  className="savings-caret pointer"
                  onClick={() => setShowWithdrawalDropdown(!showWithdrawalDropdown)}
                >
                  <IoChevronDown
                    size={16}
                    className={`caret ${showWithdrawalDropdown ? 'rotate-caret' : ''}`}
                    fill="#64748B"
                  />
                </div>
              </div>

              {showWithdrawalDropdown && (
                <div className="dropdown">
                  <NavLink to={'/withdrawal-manager'} onClick={onClose}>
                    <img src={ReciptImg} alt="" />
                    Normal Withdrawals
                  </NavLink>
                  <NavLink to={'/large-withdrawals'} onClick={onClose}>
                    <img src={ReciptImg} alt="" />
                    Large Withdrawals
                  </NavLink>
                </div>
              )}
            </li>
            {showAdminOptions && (
              <>
                <li>
                  <NavLink to={'/repush-webhook'} onClick={onClose}>
                    <img src={ReciptImg} alt="" />
                    Repush Webhook
                  </NavLink>
                </li>

                <li className="sidebar__withdrawal-manager">
                  <div className="text-caret flex--2">
                    <NavLink to={'/site-configuration/withdrawal-threshold'} onClick={onClose}>
                      <img src={SiteConfig} alt="" />
                      Site Configuration
                    </NavLink>
                    <div
                      className="savings-caret pointer"
                      onClick={() => setShowSiteConfigDropdown(!showSiteConfigDropdown)}
                    >
                      <IoChevronDown
                        size={16}
                        className={`caret ${showSiteConfigDropdown ? 'rotate-caret' : ''}`}
                        fill="#64748B"
                      />
                    </div>
                  </div>

                  {showSiteConfigDropdown && (
                    <div className="dropdown">
                      <NavLink to={'/site-configuration/withdrawal-threshold'} onClick={onClose}>
                        <img src={USDRequests} alt="" />
                        Withdrawal Threshhold
                      </NavLink>
                      <NavLink to={'/site-configuration/withdrawal-limits'} onClick={onClose}>
                        <img src={ReciptImg} alt="" />
                        Withdrawal Limit
                      </NavLink>
                    </div>
                  )}
                </li>

                <li>
                  <NavLink to={'/payment-processor'} onClick={onClose}>
                    <img src={PaymentProcessor} alt="" />
                    Payment Processor
                  </NavLink>
                </li>
              </>
            )}

            {showAdminComplianceOptions && (
              <>
                <li>
                  <NavLink to={'/repush-webhook'} onClick={onClose}>
                    <img src={ReciptImg} alt="" />
                    Repush Webhook
                  </NavLink>
                </li>
              </>
            )}

            {/* --- USD Dropdown --- */}
            <li className="sidebar__withdrawal-manager">
              <div className="text-caret flex--2">
                <NavLink
                  to={'/usd-request'}
                  onClick={onClose}
                  className={location.pathname.includes('usd') ? 'active' : ''}
                >
                  <img src={USDRequests} alt="" />
                  USD Requests
                </NavLink>

                <div className="savings-caret pointer" onClick={() => setShowUsdDropdown(!showUsdDropdown)}>
                  <IoChevronDown
                    size={16}
                    className={`caret ${showUsdDropdown ? 'rotate-caret' : ''}`}
                    fill="#64748B"
                  />
                </div>
              </div>

              {showUsdDropdown && (
                <div className="dropdown">
                  <NavLink to={'/usd-request'} onClick={onClose}>
                    <img src={USDRequests} alt="" />
                    Normal USD Requests
                  </NavLink>
                  <NavLink to={'/usd-withheld-request'} onClick={onClose}>
                    <img src={ReciptImg} alt="" />
                    Held USD Transactions
                  </NavLink>
                </div>
              )}
            </li>

            <li>
              <NavLink to={'/settings'} onClick={onClose}>
                <img src={SettingsIcon} alt="" />
                Settings
              </NavLink>
            </li>
          </ul>
        </div>

        <div id="logout">
          <span id="user-icon">{currentUser?.email?.[0]?.toUpperCase()}</span>
          <span className="user-details">
            <p id="user-name">{currentUser?.firstName}</p>
            <p id="email">{currentUser?.email}</p>
          </span>
          <button onClick={logout}>
            <img src={LogoutIcon2} alt="log out icon" />
          </button>
        </div>
      </div>
    </aside>
  );
};

export default Sidebar;
